import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface UnsupportedCodeStatusProps {
  code?: string;
  descriptionDefaultValue: string;
  descriptionI18nKey: string;
}

const UnsupportedCodeStatus = ({ code, descriptionDefaultValue, descriptionI18nKey }: UnsupportedCodeStatusProps) => {
  const { t } = useTranslation();
  const rawCode = String(code || '').trim();
  if (!rawCode) return null;

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t('controlPanel.devices.unsupportedCode.title', { defaultValue: 'Custom code' })}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
        {t(descriptionI18nKey, {
          defaultValue: descriptionDefaultValue,
          code: rawCode,
        })}
      </Typography>
    </Box>
  );
};

export default UnsupportedCodeStatus;
